import React, { PureComponent } from 'react';
import styles from './index.css';

class Header extends PureComponent {
    render() {
        return (
            <div className={styles.header_wp}>
                <div className={styles.header}>
                    <ul className={styles.linkList}>
                        <li>
                            <a
                                href="https://sports.ifeng.com/loc/olymipc2020"
                                target="_blank"
                                rel="noreferrer"
                                className={styles.home}>
                                <span>奥运首页</span>
                            </a>
                        </li>
                        <li>
                            <a href="http://sports.ifeng.com/zhty/" target="_blank" rel="noreferrer">
                                滚动新闻
                            </a>
                        </li>
                        <li>
                            <a href="https://sports.ifeng.com/c/special/87eoUr5Z3r6" target="_blank" rel="noreferrer">
                                中国骄傲
                            </a>
                        </li>
                        <li>
                            <a href="https://sports.ifeng.com/c/special/87v9D42snR2" target="_blank" rel="noreferrer">
                                原创策划
                            </a>
                        </li>
                        <li>
                            <a href="http://sports.ifeng.com/photo/" target="_blank" rel="noreferrer">
                                精彩图集
                            </a>
                        </li>
                        <li>
                            <a href="https://flive.ifeng.com/live/1002778.html" target="_blank" rel="noreferrer">
                                图文直播
                            </a>
                        </li>
                        <li>
                            <a href="https://sports.ifeng.com/c/special/87eoRvAxSTY" target="_blank" rel="noreferrer">
                                完整赛程
                            </a>
                        </li>
                        <li>
                            <a href="https://sports.ifeng.com/c/special/87eoNWoq9ZY" target="_blank" rel="noreferrer">
                                奖牌榜
                            </a>
                        </li>
                    </ul>
                    <div className="sports_s">
                        <a href="http://sports.ifeng.com/" target="_blank" rel="noreferrer">
                            体育首页
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}

export default Header;
